import { get } from 'lodash';

type CSVField = {
  email: string[];
  name: string;
  phone: string[];
  role: string;
  socialMediaHandle: string;
  source: string;
  url: string[];
};

type CSVTitles = {
  key: string;
  title: string;
};

type CSVData = {
  filename: string;
  data: CSVField[];
  itemTitles: CSVTitles[];
};

export const downloadPeopleCSV = ({ data, itemTitles, filename }: CSVData) => {
  if (!data.length) return;

  const headers = itemTitles.map(({ title }) => title);

  const csvRows = [
    headers.join(','),
    ...data.map(row =>
      itemTitles
        .map(({ key }) => {
          const value = get(row, key);
          const escaped =
            typeof value === 'string'
              ? `"${value.replace(/"/g, '""')}"`
              : value
              ? `"${value}"`
              : '';
          return escaped;
        })
        .join(',')
    ),
  ];

  const csvString = csvRows.join('\n');

  const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });

  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(link.href);
};
